export enum LayoutTypes {
    COLUMN = "column",
    ROW = "row"
}